import { get, post, del } from './base'

export const getOne = (id) => get(`train/${id}`)

export const create = (call) => post(`train`, call)

export const remove = (id) => del(`train`)

export const getLabels = () => get('train/labels')
